"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChattersList = void 0;
const tslib_1 = require("tslib");
const shared_utils_1 = require("@d-fischer/shared-utils");
const common_1 = require("@twurple/common");
/**
 * A list of chatters in a Twitch chat.
 */
let ChattersList = class ChattersList extends common_1.DataObject {
    /**
     * A list of user names of all chatters in the chat.
     */
    get allChatters() {
        return (0, shared_utils_1.flatten)(Object.values(this[common_1.rawDataSymbol].chatters));
    }
    /**
     * A map of user names of all chatters in the chat, mapped to their status in the channel.
     */
    get allChattersWithStatus() {
        return new Map((0, shared_utils_1.flatten)(Object.entries(this[common_1.rawDataSymbol].chatters).map(([status, names]) => names.map(name => [name, status]))));
    }
};
ChattersList = tslib_1.__decorate([
    (0, common_1.rtfm)('api', 'ChattersList')
], ChattersList);
exports.ChattersList = ChattersList;
